import { useState } from 'react'
import type { LessonCount } from '@/features/ai/useStartGeneration'

export interface GenerationSettingsState {
  lessonCount: LessonCount
  setLessonCount: (n: LessonCount) => void
}

/** Состояние панели настроек генерации. Отдельно от AISidebar, чтобы тот
 *  оставался в лимите 120 строк и читался как композиция, а не как форма.
 *
 *  Раньше здесь жили ещё `designSystemId`/`imageModel`/`skipImages` — под
 *  ними нет бэка (модели картинок и дизайн-системы ручка не отдаёт, флаг
 *  пропуска картинок нечего пропускать), Task 11 их убрал вместе с
 *  пикерами. Языка тут нет и не будет: сайдбар генерирует В СУЩЕСТВУЮЩИЙ
 *  курс, бэк поле `language` игнорирует и берёт `sourceLang` курса. */
export const useGenerationSettings = (): GenerationSettingsState => {
  const [lessonCount, setLessonCount] = useState<LessonCount>(3)

  return { lessonCount, setLessonCount }
}
